<template>
	<div>
		<header class="header">
			<img src="./images/insurer_bg.png" alt="">
			<navHeader ref=navHeader></navHeader>
			<div class="dbox">
				<p>{{langtrans().bxgsjy[languageIndex]}}</p>
			</div>
			<div class="points_box">
				<h3>{{langtrans().wmllnz[languageIndex]}}</h3>
				<p>{{langtrans().ddjxjy[languageIndex]}}（LBS）{{langtrans().ttggzh[languageIndex]}}</p>
			</div>
		</header>
		<main class="main">
			<h2 class="title">{{langtrans().ddjxjy[languageIndex]}}</h2>
			<ul class="list">
				<li>
					<img src="./images/insurer_icon_01.png" alt="">
					<h4>{{langtrans().qjdyxc[languageIndex]}}</h4>
					<p>24h{{langtrans().jyjjdd[languageIndex]}}</p>
				</li>
				<li>
					<img src="./images/insurer_icon_02.png" alt="">
					<h4>700+{{langtrans().jyjg[languageIndex]}}</h4>
					<p>{{langtrans().fggqqz[languageIndex]}}</p>
				</li>
				<li>
					<img src="./images/insurer_icon_03.png" alt="">
					<h4>2500+{{langtrans().jzxss[languageIndex]}}</h4>
					<p>{{langtrans().bpbqqg[languageIndex]}}</p>
				</li>
			</ul>
			<p class="btn_node">
				<button @click="setjlhz">{{langtrans().jlhgzz[languageIndex]}}</button>
			</p>
		</main>
		<jlhzBox ref=jlhzBox></jlhzBox>
		<vFooter @performHeader=performHeader></vFooter>
	</div>
</template>

<script>
import langtrans from "@/assets/languagejs/insurer.vue.trans.js";
	import { Message } from "element-ui";
	import constants from "@/util/constants.js";
	import navHeader from '@/components/header/indexHeader'
	import vFooter from '@/components/footer/indexFooter'
	import { postCooperation } from '@/views/axios/api.js';
	import jlhzBox from './jlhz'
 	export default {
		data() {
			return {
				flag: true,
				usertype: "",
				user: "",
				pwd: "",
				form: {},
				successdialog: false,
				dialogFormVisible: false
			};
		},
		components: {
			navHeader,
			vFooter,
			jlhzBox
		},
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},	
		methods: {
			langtrans(){
				return langtrans
			},
			setjlhz(){
				this.$refs.jlhzBox.setpopShow('true',1)
			},
			performHeader(str){
				this.$refs.navHeader.login(str)
			},
		}
	};
</script>

<style scoped>
	@import url(./css/programme.css);
</style>



// WEBPACK FOOTER //
// src/components/programme/insurer.vue